<template>
  <div class="widget-instructions-one">
    <p class="widget-instructions">
      {{ $t("widget_details.step_1") }}
    </p>
    <br />
    <div class="columns">
      <div class="column is-12">
        <div class="tile is-ancestor">
          <div class="tile is-parent">
            <div class="tile  box custom-tile code-demo">
              <div class="header">
                <ButtonCopy class="is-pulled-right is-small"></ButtonCopy>
              </div>
              <div class="instructions-box content">
                <p class="sample-code lorem-code">
                  &lt;html&gt; <br />
                  &nbsp;&lt;head&gt;
                </p>
                <div ref="text">
                  <p class="sample-code script-text">
                    &lt;meta charset="utf-8"&gt;
                  </p>
                  <!-- <p class="sample-code comment-code">
                  <p class="sample-code comment-code">
                    &lt;!--
                    {{ $t("widget_details.polyfill_tag") }} --&gt; <br />
                    &lt;!-- custom-elements polyfill --&gt;
                  </p>
                  <p class="sample-code script-text">
                    &lt;script
                    src="https://unpkg.com/@ungap/custom-elements"&gt;&lt;/script&gt;
                  </p>
                  <p class="sample-code comment-code">
                    &lt;!-- ES5 and ES6 polyfill --&gt;
                  </p>
                  <p class="sample-code script-text">
                    &lt;script
                    src="https://polyfill.io/v3/polyfill.min.js?features=es6%2Ces5"&gt;&lt;/script&gt;
                  </p>
                  //-->
                  <!-- <p class="sample-code comment-code">
                    &lt;!-- Smooth scroll polyfill --&gt;
                  </p>
                  <p class="sample-code script-text">
                    &lt;script
                    src="https://unpkg.com/smoothscroll-polyfill@0.4.3/dist/smoothscroll.min.js"&gt;&lt;/script&gt;
                  </p> -->
                  <p class="sample-code comment-code">
                    &lt;!--
                    {{ $t("widget_details.vue_tag") }} --&gt;
                  </p>

                  <p class="sample-code script-text">
                    &lt;script
                    src="https://cdn.jsdelivr.net/npm/vue@2.6.11"&gt;&lt;/script&gt;
                    <br />
                  </p>
                  <p class="sample-code comment-code">
                    &lt;!--
                    {{ $t("widget_details.buefy_tag") }} --&gt;
                  </p>

                  <p class="sample-code script-text">
                    &lt;link rel="stylesheet"
                    href="https://unpkg.com/buefy/dist/buefy.min.css"&gt;
                    <br />
                  </p>
                  <p class="sample-code comment-code">
                    &lt;!--
                    {{ $t("widget_details.fontawesome_tag") }} --&gt;
                  </p>

                  <p class="sample-code script-text">
                    &lt;link rel="stylesheet"
                    href="https://use.fontawesome.com/releases/v5.2.0/css/all.css"&gt;
                    <br />
                  </p>
                </div>
                <p class="sample-code lorem-code">&nbsp;&lt;/head&gt; <br /></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonCopy from "@/components/ButtonCopy.vue";
export default {
  name: "WidgetInstructionsOne",
  props: {
    widget: { type: Object, required: true }
  },
  data() {
    return {
      toggle: false,
      selectedData: [] // Must be an array reference
    };
  },
  components: {
    ButtonCopy
  }
};
</script>
<style lang="scss">
/* slide animation */
.slide-enter-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to,
.slide-leave {
  max-height: 100px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}
p.click_title {
  margin-top: 12px;
  margin-bottom: 8px;
}
.instructions-box.content {
  padding: 10px;
}

.code-demo {
  margin-bottom: 30px;
}
@media screen and (max-width: 416px) {
  .is-pulled-right {
    font-size: 80%;
  }
  .code-demo {
    overflow-wrap: break-word;
  }
}
</style>
